/* ==========================================================================
   Sticky Add to Cart — Lumvari
   Theme-agnostic: shows/hides on scroll, keeps price/variant in sync with
   whatever variant picker your product template already uses, and adds
   the selected variant to the cart via Shopify's AJAX Cart API.
   ========================================================================== */

(function () {
  "use strict";

  function firstVisible(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) return list[i];
    }
    return list.length ? list[0] : null;
  }

  function moneyFormat(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (e) {
        /* fall through to default */
      }
    }
    return "$" + value;
  }

  function init(bar) {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var button = bar.querySelector("#sticky-atc-button");
    var buttonLabel = bar.querySelector(".sticky-atc__button-label");
    var priceEl = bar.querySelector("[data-sticky-atc-price]");
    var compareEl = bar.querySelector("[data-sticky-atc-compare]");
    var toast = bar.querySelector("#sticky-atc-toast");
    var toastTimer = null;

    var addText = button.dataset.addText || "Add to Cart";
    var soldOutText = button.dataset.soldOutText || "Sold Out";
    var addedText = button.dataset.addedText || "Added ✓";

    var variants = [];
    var variantsScript = document.querySelector("[data-sticky-atc-variants]");
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var lastVariantId = button.dataset.variantId;

    function findFormVariantId() {
      if (!productForm) return null;
      var idInput = productForm.querySelector('[name="id"]');
      return idInput ? idInput.value : null;
    }

    function applyVariant(variantId) {
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) return;

      button.dataset.variantId = variant.id;

      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = moneyFormat(variant.compare_at_price);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }

      if (variant.available) {
        button.disabled = false;
        button.classList.remove("is-disabled");
        if (buttonLabel) buttonLabel.textContent = addText;
      } else {
        button.disabled = true;
        button.classList.add("is-disabled");
        if (buttonLabel) buttonLabel.textContent = soldOutText;
      }
    }

    if (productForm) {
      setInterval(function () {
        var currentId = findFormVariantId();
        if (currentId && currentId !== lastVariantId) {
          lastVariantId = currentId;
          applyVariant(currentId);
        }
      }, 400);
    }
    // Show / hide on scroll -------------------------------------------------
    var trigger = firstVisible(document.querySelectorAll('#sticky-atc-trigger'));

    function showBar() {
      bar.classList.add("is-visible");
      bar.setAttribute("aria-hidden", "false");
    }

    function hideBar() {
      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
    }

    var onProductPage = !!productForm;
    var onCartOrCheckout = /\/(cart|checkout)/.test(window.location.pathname);

    if (onProductPage && !onCartOrCheckout) {
      if (trigger && "IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                hideBar();
              } else if (entry.boundingClientRect.top < 0) {
                showBar();
              }
            });
          },
          { threshold: 0 }
        );
        observer.observe(trigger);
      } else {
        window.addEventListener(
          "scroll",
          function () {
            if (window.scrollY > 600) {
              showBar();
            } else {
              hideBar();
            }
          },
          { passive: true }
        );
      }
    }

    // Add to cart -------------------------------------------------------
    button.addEventListener("click", function () {
      if (button.disabled || button.classList.contains("is-loading")) return;

      var variantId = findFormVariantId() || button.dataset.variantId;
      if (!variantId) return;

      button.classList.add("is-loading");

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          button.classList.remove("is-loading");
          button.classList.add("is-success");
          if (buttonLabel) buttonLabel.textContent = addedText;

          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("cart:updated"));

          if (toast) {
            toast.classList.add("is-visible");
            clearTimeout(toastTimer);
            toastTimer = setTimeout(function () {
              toast.classList.remove("is-visible");
            }, 3200);
          }

          setTimeout(function () {
            button.classList.remove("is-success");
            if (buttonLabel) buttonLabel.textContent = addText;
          }, 1800);
        })
        .catch(function (err) {
          button.classList.remove("is-loading");
          if (buttonLabel) {
            buttonLabel.textContent = "Try again";
            setTimeout(function () {
              buttonLabel.textContent = addText;
            }, 2000);
          }
          console.error("Sticky add-to-cart error:", err);
        });
    });
  }

  function ready() {
    var bar = firstVisible(document.querySelectorAll('#sticky-atc'));
    if (bar) init(bar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
})();